import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Container,
  Box,
  Card,
  Grid,
  CircularProgress,
  Typography,
  Pagination,
} from "@mui/material";
import { FaMapLocationDot, FaCamera } from "react-icons/fa6";
import {
  COMPANY,
  PROJECT,
  TIMELAPSE,
  IMGARCHIVE,
  IMGARCHIVEALL,
} from "../../services/actions";
import Form from "./Form";
import ProgressBar from "../extra/ProgressBar";
import InfoCard2 from "../extra/InfoCard2";
import logPng from "./log.png";

const formattedDate = (isoString) => {
  try {
    const date = new Date(isoString);
    const fd = date.toISOString().split("T")[0]; // "2025-05-23"
    const day = date.getUTCDate(); // returns 23
    console.log(day);
    return { date: fd, day: day };
  } catch (err) { }
};

export default function ImageArchive() {
  const documentStyle = getComputedStyle(document.documentElement);
  let dispatch = useDispatch();
  const navigate = useNavigate();
  let projectState = useSelector((state) => state?.projectState);
  let companyState = useSelector((state) => state?.companyState);
  let timelapseState = useSelector((state) => state?.timelapseState);
  let imgarchiveState = useSelector((state) => state?.imgarchiveState);
  let imgarchiveallState = useSelector((state) => state?.imgarchiveallState);
  const [companies, setCompanies] = React.useState([]);
  let user = useSelector((state) => state?.loginState?.auth);
  const [defV, setDefV] = React.useState({});
  const [loader, setLoader] = React.useState(false);
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchImageArchives = (page = 0) => {
    const url = page === 0 ? `zip/${page}/` : `zip/?page=${page}`; // pass page number
    dispatch({ type: `${IMGARCHIVEALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    try {
      if (user.main_role == "Company") {
        setCompanies(user?.companies);
      } else {
        dispatch({ type: `${COMPANY}_GET`, payload: 0 });
        //dispatch({ type: `${IMGARCHIVEALL}_GET`, payload: 0 })
        fetchImageArchives(0);
      }
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchImageArchives(page);
  }, [page]);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results);
  }, [companyState?.data]);

  React.useEffect(() => {
    setLoader(false);
    dispatch({ type: `${IMGARCHIVEALL}_GET`, payload: 0 });
  }, [imgarchiveState.data]);

  const handleFormOpen = () => { };
  const handleDelete = (id) => {
    dispatch({ type: `${IMGARCHIVE}_DELETE`, payload: id });
  };

  return (
    <>
      <Container maxWidth="false" className="py-3">
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, md: 12 }}>
            <Card
              sx={{
                px: 3,
                py: 2,
                background: "#ffffff8f",
                borderRadius: 4,
                width: 1,
                mb: 2,
                mt: 3,
              }}
            >
              <Form
                companies={companies}
                projects={projectState?.data?.results}
                cameras={timelapseState?.data?.results}
                defaultValues={defV}
                onSubmit={(data) => {
                  setLoader(true);
                  let ACTION = data.id
                    ? `${IMGARCHIVE}_PATCH`
                    : `${IMGARCHIVE}_POST`;
                  dispatch({ type: ACTION, payload: data });
                }}
                onChange={(action, value) => {
                  console.log(action, value);
                  if (value) {
                    if (action == "project") {
                      dispatch({
                        type: `${TIMELAPSE}_GET`,
                        payload: `timelapse/0/?filter_by={"project":"${value}"}`,
                      });
                    } else {
                      dispatch({
                        type: `${PROJECT}_GET`,
                        payload: `project/0/?filter_by={"company":"${value}"}`,
                      });
                    }
                  }
                }}
              />
            </Card>
            {loader && <ProgressBar />}
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {(imgarchiveallState?.data?.results || []).map((data) => {
            const _from = formattedDate(data.date_from);
            const _to = formattedDate(data.date_to);
            data.to_day = _to.day;
            data.from_day = _from.day;
            data.date = _from.date + "-" + _to.date;
            data.image = logPng;
            data.fname = data.company_name + " " + data.project_name;
            return (
              <>
                <Grid size={{ xs: 12, sm: 2, md: 3 }}>
                  <InfoCard2
                    img_type={"company"}
                    keys={[
                      "image",
                      "camera_name",
                      "fname",
                      "date",
                      "From",
                      "from_day",
                      "Up To",
                      "to_day",
                      "Images",
                      "file_count",

                    ]}
                    data={data}
                    onClick={() => {
                      // navigate if needed
                    }}
                    onAction={(action) => {
                      if (action === "Edit") {
                        handleFormOpen(data);
                      } else if (action === "Delete") {
                        handleDelete(data.id);
                      }
                    }}
                  />
                </Grid>
              </>
            );
          })}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.ceil(imgarchiveallState?.data?.count / pageSize)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </Container>
    </>
  );
}
